import { type RootState } from '@/store';

export const isAppLoading = ({ loader: { pendingCalls } }: RootState) =>
  Object.values(pendingCalls).some(Boolean);
